<div class="ion-header ion-hide-lg-up s">
  <header-main></header-main>
</div>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down s">
    <header-desktop></header-desktop>
    <div class="container ion-padding-top">
      <h1>How can we help?</h1>
      <div class="row">
        <div class="col-xs-12 col-md-6 col-md-offset-3 col-xl-4 col-xl-offset-4">
          <div class="support-search">
            <input class="ion-searchbar ion-no-padding" (input)="getSearch($event)" [(ngModel)]="keyword" type="search" placeholder="Enter Keywords" />
            <button color="tertiary" shape="round" size="large" item-right>Search</button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div class="container">
    <div class="support-select ion-margin">
      <select #typeSelect (change)="getTypeSelect(typeSelect.value)" value="{{selectedType}}">
        <option *ngFor="let usertype of usertypes" value="{{usertype.key}}" [selected]="selectedType == usertype.key">{{ usertype.type }}</option>
      </select>
    </div>
  </div>

  <div class="support-tabs">
    <div class="container">
        <span class="support-tabs-btn" *ngFor="let usertype of usertypes" [ngClass]="{'active': selectedType === usertype.key}" (click)="getTypeTab(usertype.key)">
          {{ usertype.type }}
          <a class="ion-hide" href="/support/{{usertype.key.replace('_','-')}}">{{ usertype.type }}</a>
        </span>
    </div>
  </div>
  
  <div class="support-tabs-content">
    <div class="container">
      <div class="support-grid">
        <div class="support-col" *ngFor="let article of articles">
          <div class="support-icon-boxes {{selectedType.toLowerCase().replace('_','-')}}" (click)="supportDetail(selectedType.toLowerCase().replace('_','-'), article.seo.canonicalUrl)">
            <div class="support-icon">
              <div *ngIf="article.thumbnail.length > 0">
                <img [src]="article.thumbnail[0]" />
              </div>
              <img src="assets/icons/ge-core.svg" *ngIf="article.thumbnail.length == 0" />
            </div>
            <span class="title">{{ article.title }}</span>
            <a class="ion-hide" href="/support/{{selectedType.toLowerCase().replace('_','-')}}/{{article.seo.canonicalUrl}}">{{ article.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="services landing">
    <faq-services [service]="selectedType"></faq-services>

    <div class="sign-up-banner">
      <div class="sub-heading">
        <h6>Sign up and begin completing your gigs with us - <a href="/sign-up"><button class="button button-white button-round">Click Here</button></a></h6>
      </div>
    </div>
  </div>
  
  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
